export const MAX_OFFSET_SECONDS = 31 * 24 * 60 * 60

export function offsetToForm(seconds, preferMinutes = false) {
  if (seconds == null || !Number.isSafeInteger(seconds) || seconds < 0) {
    return { value: '', unit: preferMinutes ? 'minutes' : 'seconds' }
  }
  const useMinutes = preferMinutes && seconds % 60 === 0
  return { value: String(useMinutes ? seconds / 60 : seconds), unit: useMinutes ? 'minutes' : 'seconds' }
}

export function formToOffset(field, label) {
  if (!field || !['seconds', 'minutes'].includes(field.unit) ||
      typeof field.value !== 'string' || !/^\d+$/.test(field.value.trim())) {
    throw new Error(`${label}: nhập số nguyên không âm và chọn đơn vị`)
  }
  const seconds = Number(field.value.trim()) * (field.unit === 'minutes' ? 60 : 1)
  if (!Number.isSafeInteger(seconds) || seconds < 0 || seconds > MAX_OFFSET_SECONDS) {
    throw new Error(`${label}: thời gian không được vượt 31 ngày`)
  }
  return seconds
}

export function legacyOffsetSuggestion(periods, field) {
  if (!periods?.length) return null
  const offsets = periods.map(period => {
    if (!period.dialDate || !period.legacy?.[field]) return null
    const seconds = (new Date(period.dialDate).getTime() - new Date(period.legacy[field]).getTime()) / 1000
    return Number.isSafeInteger(seconds) && seconds >= 0 && seconds <= MAX_OFFSET_SECONDS ? seconds : null
  })
  // Differing schedules/legacy behavior must be confirmed, not silently collapsed.
  return offsets.every(value => value !== null && value === offsets[0]) ? offsets[0] : null
}

export function draftDeadline(drawAt, field, unlimited = false) {
  if (unlimited) return 'Không giới hạn'
  try {
    const seconds = formToOffset(field, 'Mốc thời gian')
    const draw = new Date(drawAt)
    const deadline = new Date(draw.getTime() - seconds * 1000)
    if (!Number.isFinite(deadline.getTime())) return 'Chưa xác định được kỳ'
    return new Intl.DateTimeFormat('vi-VN', {
      timeZone: 'Asia/Ho_Chi_Minh', day: '2-digit', month: '2-digit', year: 'numeric',
      hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23',
    }).format(deadline)
  } catch (_) { return 'Chưa nhập hợp lệ' }
}
